module.exports = __webpack_public_path__ + "static/media/cmautomazione.89254644.jpg";